module.exports = __webpack_public_path__ + "static/media/VIP_1.fd21d1c2.jpg";